//
import React, { useState, useEffect } from 'react'

import ReviewInfo from 'src/views/review/detail'

//  ** Services
import SEOHeader from 'src/views/seo/head'
// import CryptoJS from 'crypto-js'
import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'

// ** SSR
import serverProps from 'src/@core/services/ssr/serverProps'
import absoluteUrl from 'next-absolute-url'

// Redux
import { connect } from 'react-redux'
import { compose } from 'redux'
import { updateDeviceInfo } from 'src/@core/redux/actions'

// ** Utils
import { getObjectValueWithDefaultValue } from 'src/@core/utils/utils'
import isEmpty from 'lodash/isEmpty'
// import { isLocalHost } from 'src/@core/utils/domUtils'
// import { v4 as uuidv4 } from 'uuid'

// ** Services

//  Constants
import { stp } from 'src/constants/Constants'

export async function getServerSideProps(context) {
  const { query, req, res } = context
  //
  res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=59')
  // const { slug } = context.query
  const slug = query.slug
  // Call an external API endpoint to get posts.
  let reviewData = null
  //
  const { origin } = absoluteUrl(req, req.headers.host)
  const url = `${origin}/api/review/${slug}`
  const responseReview = await fetch(url)
  if (responseReview) {
    const status = responseReview.status
    if (status === 200) {
      const body = await responseReview.json()
      //
      if (body.data) {
        reviewData = body.data
      }
    }
  }

  const deviceInfoProps = await serverProps(context)
  const deviceInfo = deviceInfoProps.props.deviceInfo
  const settingInfo = deviceInfoProps.props.settingInfo
  // will receive `posts` as a prop at build time
  return {
    props: {
      reviewData: reviewData,
      deviceInfo: deviceInfo,
      settingInfo: settingInfo
    }
  }
}

// eslint-disable-next-line no-unused-vars
const ReviewInfoPage = props => {
  const [reviewData, setReviewData] = useState({})
  //
  useEffect(() => {
    if (!isEmpty(props.deviceInfo)) {
      props.updateDeviceInfo(props.deviceInfo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.deviceInfo])
  //
  useEffect(() => {
    if (!isEmpty(props.reviewData)) {
      if (!isEmpty(props.reviewData.data)) {
        //
        const dataObject = props.reviewData.data

        // const dataDescrypted = dataObject.data

        const bytes = AES.decrypt(dataObject, stp)
        const originalText = bytes.toString(Utf8)
        const dataJSON = JSON.parse(originalText)
        //
        if (!isEmpty(dataJSON)) {
          setReviewData(dataJSON)
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reviewData])

  function getTitleSEO(mediaInfo) {
    return getObjectValueWithDefaultValue(
      mediaInfo,
      'title',
      'IELTS Prediction - Cộng đồng học tập, trau dồi bài thi IELTS Quốc tế'
    )
  }

  function getDescriptionSEO(mediaInfo) {
    return getObjectValueWithDefaultValue(
      mediaInfo,
      'shortDescription',
      'IELTS Prediction - Cộng đồng học tập, ôn luyện, trau dồi bài thi IELTS Quốc tế 🚀 – Nguồn tham khảo uy tín cho học viên.'
    )
  }

  //
  return (
    <>
      <SEOHeader title={getTitleSEO(props.reviewData)} description={getDescriptionSEO(props.reviewData)} />
      <ReviewInfo reviewData={reviewData} />
    </>
  )
}

export function mapDispatchToProps(dispatch) {
  return {
    updateDeviceInfo: value => dispatch(updateDeviceInfo(value))
  }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(React.memo, withConnect)(ReviewInfoPage)
